import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({    
  state: {
    modal: {
			isOpen: false,
			message: '',
		},
  },
  getters: {
  },
  mutations: {
    commitModalOpen(state, payload) {
			state.modal = payload
		},
  },
  actions: {
    actionModalOpen({ commit }, payload) {
			commit('commitModalOpen', payload)
		},
  },
  modules: {
  }
})
